module.exports = __webpack_public_path__ + "img/aftab.4f1790d7.webp";